import {Component, EventEmitter, Inject, isDevMode, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {DataConfig} from '../../../shared/models/tabs-data';
import {Observable, Subscription} from 'rxjs';
import {SubscriptionSiteForm} from '../../models/site-form';
import {select, Store} from '@ngrx/store';
import * as fromSites from '../../reducers';
import * as fromShared from '../../../shared/reducers';
import {Culture, Timezone, WarningToastAction} from '../../../shared';
import {ServerForm, ServerFormUrl} from '../../../shared/models/servers';
import {SiteGetInfoService} from '../../services/site-get-info.service';
import {debounceTime, distinctUntilChanged, skipWhile} from 'rxjs/operators';
import {StatusToOffComponent} from '../modal-status-to-off/status-to-off.component';
import {LoadProductsCompleteListAction, LoadProductsCompleteListClearAction} from '../../../shared/actions/product-complete-list';
import {LoadProductsAction, LoadProductsByServiceAction} from '../../../shared/actions/product';
import {L10N_LOCALE, L10nLocale, L10nTranslationService} from 'angular-l10n';
import {LoadServerURLAction} from '../../../shared/actions/servers-url';
import * as fromRoot from '../../../shared/reducers';
import {ActivatedRoute, Router} from '@angular/router';
import {Concept} from '../../../shared/models/concept';
import {Site} from '../../../shared/models/site';
import {SubscriptionI} from '../../../shared/models/subscription-i';
import {FormGroup, Validators} from '@angular/forms';
import {FindInvalidControlsService} from '../../../shared/services/find-invalid-controls.service';

@Component({
  selector: 'storever-subscription-edit',
  templateUrl: './subscription-edit.component.html',
  styleUrls: ['./subscription-edit.component.scss']
})
export class SubscriptionEditComponent  implements OnInit, OnDestroy {

  dataConfig: DataConfig;
  content: Observable<SubscriptionSiteForm>;
  @Output() saveForm = new EventEmitter<Object>();
  private sub$: Subscription;
  private subscriptions = [];
  public isVideoProduct: boolean;
  public isConcepts = false;
  servers$: Observable<ServerForm[]>;
  site$: Observable<Site>;
  cms$: Observable<ServerForm[]>;
  concept$: Observable<Concept[]>;
  serverURLS$: Observable<ServerFormUrl[]>;
  // tslint:disable-next-line:no-any
  mySite: any;
  // tslint:disable-next-line:no-any
  mySubscription: any;
  @ViewChild('statusToOff' , {static: false}) statusToOff: StatusToOffComponent;

  constructor(private store: Store<fromSites.AppState>,
              private storeRoot: Store<fromRoot.AppState>,
              private storeSites: Store<fromSites.AppState>,
              private router: Router,
              private findInvalidControlsService: FindInvalidControlsService,
              private activatedRoute: ActivatedRoute,
              private siteGetInfoService: SiteGetInfoService ,
              private translation: L10nTranslationService ,
              @Inject(L10N_LOCALE) public locale: L10nLocale) {
    this.site$ = this.storeSites.pipe(select(fromSites.selectors.getSite));
  }

  ngOnInit(): void {
    this.dataConfig.form.disable();
    this.dataConfigContentPatchForm();
    this.cultureValueChangesMap();
    this.timezoneValueChangesMap();
    this.productValueChanges();
    this.store.dispatch(new LoadProductsCompleteListAction());
   // this.loadProduct();
    this.verifyConcept();
    this.warningChangeOrientation();
    this.loadServerUrlList();
    this.loadConcept();

    this.sub$ =   this.site$.subscribe(data => {
      if (data) {
        this.mySite = data;
        for (let pi = 0; pi < data.subscriptions.length; pi++) {
         if ( this.dataConfig.form.get(['subscription', 'name']).value === data.subscriptions[pi].name) {
           this.mySubscription = data.subscriptions[pi];
         }
        }
      }
    })
    this.subscriptions.push(this.sub$);
    this.cms$ = this.store.pipe(select(fromRoot.selectors.getCMS));
    this.cms$.subscribe(data => {
      if (data && data.length > 0) {
        this.dataConfig.form.get(['serverForm' , 'cms', 'id']).updateValueAndValidity();
        this.dataConfig.form.get(['serverForm' , 'cms', 'id']).setValidators([Validators.required]);
        for (let q = 0; q < data.length; q++) {
            if (!this.dataConfig.form.get(['serverForm' , 'cms', 'id']).value &&
              data[q].name.toLowerCase().search('dxp') !== -1 ) {
              this.dataConfig.form.get(['serverForm' , 'cms', 'id']).patchValue(data[q].id)
            }
            if (!this.dataConfig.form.get(['serverForm' , 'cms', 'id']).value &&
              this.isVideoProduct && data[q].name.toLowerCase().search('ds') !== -1) {
              this.dataConfig.form.get(['serverForm' , 'cms', 'id']).patchValue(data[q].id)
            }
            if (!this.dataConfig.form.get(['serverForm' , 'cms', 'id']).value &&
              !this.isVideoProduct && data[q].name.toLowerCase().search('mus') !== -1) {
              this.dataConfig.form.get(['serverForm' , 'cms', 'id']).patchValue(data[q].id)
            }
          }
        if (!this.dataConfig.form.get(['serverForm' , 'cms', 'id']).value) {
          this.dataConfig.form.get(['serverForm' , 'cms', 'id']).patchValue(data[0].id)
          }
      } else {
        this.dataConfig.form.get(['serverForm' , 'cms', 'id']).clearValidators();
        this.dataConfig.form.get(['serverForm' , 'cms', 'id']).updateValueAndValidity();
    }
    })
  }
  loadConcept(): void {
    this.concept$ =  this.storeSites.pipe(select(fromSites.selectors.getConceptsBySubscription));
    this.concept$.subscribe(data => {
      const conceptsIds  = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          conceptsIds.push(data[i].id)
        }
        this.dataConfig.form.get(['concepts', 'concepts', 'id']).patchValue(conceptsIds)
      }
    });
  }


  loadProduct(): void {
   /* this.sub$ = this.dataConfig.form.get(['subscription' , 'service' , 'id']).valueChanges.subscribe(value => {
      if (value) {
        this.storeRoot.dispatch(new LoadProductsByServiceAction(value));
      }
    })
    this.subscriptions.push(this.sub$);*/
  }

  verifyConcept(): void {
    this.sub$ = this.dataConfig.form.get(['serverForm' , 'cms' , 'id']).valueChanges.subscribe(value => {
      if (value && value.toLowerCase().search('dxp') !== -1) {
        this.isConcepts = true;
      } else {
        this.isConcepts = false;
      }
    })
    this.subscriptions.push(this.sub$);


  }
  // loadServerUrlList(): void {
  //   this.sub$ = this.dataConfig.form.get(['serverForm' , 'cms',  'id']).valueChanges.pipe(
  //     debounceTime(700)
  //   ).subscribe(val => {
  //     if (val) {
  //       console.log(this.isVideo)
  //       this.storeRoot.dispatch(new LoadServerURLAction({
  //         'server' : val,
  //         'serviceType': !this.isVideo  ? 1 : 2
  //       }));
  //     }
  //   })
  //   this.subscriptions.push(this.sub$);
  // }
  loadServerUrlList(): void {
    this.serverURLS$ = this.storeRoot.pipe(select(fromRoot.selectors.getServerUrl));
    this.serverURLS$.subscribe(data => {
      if (data && data.length) {
        if (!this.dataConfig.form.get(['serverForm' , 'url', 'id']).value) {
          this.dataConfig.form.get(['serverForm' , 'url', 'id']).patchValue(data[0].id);
        }

      }
    })
    this.sub$ = this.dataConfig.form.get(['serverForm' , 'cms', 'id']).valueChanges.pipe(
      debounceTime(700)
    ).subscribe(val => {
      if (val ) {
        if ( this.dataConfig.form.get(['subscription' , 'service' , 'id']).value === 1) {
          this.store.dispatch(new LoadServerURLAction({  'server' : val, 'serviceType':  1}));
        }
        if ( this.dataConfig.form.get(['subscription' , 'service' , 'id']).value === 2) {
          this.store.dispatch(new LoadServerURLAction({  'server' : val, 'serviceType':  2}));
        }
      }
    })
    this.subscriptions.push(this.sub$);
  }

  warningChangeOrientation(): void {
    let screenOrientationId = this.dataConfig.form.get(['videoOption', 'screenRotation' , 'id']).value;
    this.sub$ = this.dataConfig.form.get(['videoOption' , 'screenRotation' , 'id']).valueChanges.subscribe(val => {
      if (screenOrientationId === null) {
        screenOrientationId = val;
      }
      else if (screenOrientationId !== val) {
        this.dispatchWarningToast('WARNING_ORIENTATION_CHANGE_AFFECT_MEDIA');
      }
      screenOrientationId = val;
    });
    this.subscriptions.push(this.sub$);
  }

  dispatchWarningToast(message: string): void {
    this.store.dispatch(new WarningToastAction({
      message: this.translation.translate(message),
      title: 'WARNING'
    }));
  }
  ngOnDestroy(): void {
    this.dataConfig.form.markAsPristine();
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    this.store.dispatch(new LoadProductsCompleteListClearAction());
    this.store.dispatch(new LoadProductsAction());
  }



  dataConfigContentPatchForm(formPath?: string[]): void {

    this.content = this.dataConfig.content;
    this.sub$ = this.content.subscribe(sub => {


      if (formPath) {
        this.dataConfig.form.get(formPath).patchValue(sub[formPath[0]]);
        this.dataConfig.form.get(['subscription' , 'cultures' , 'code']).patchValue(sub.subscription.cultures);
      } else {
       // if (!this.dataConfig.form.get(['subscription' , 'name']).value) {
          this.dataConfig.form.patchValue(sub);
          this.dataConfig.form.get(['subscription' , 'cultures' , 'code']).patchValue(sub.subscription.cultures);
      //  }
      }
      this.setStatusPresentationInDetailIfOff();
    });
    this.subscriptions.push(this.sub$);
  }

  setStatusPresentationInDetailIfOff(): void {
    if (this.dataConfig.form.get(['subscription', 'status', 'id']).value === 1) {
      this.dataConfig.groupConfigs.groupConfigs[1].config[2].presentation = 'detail';
    } else {
      this.dataConfig.groupConfigs.groupConfigs[1].config[2].presentation = 'edit';
    }
  }

  /**
   * - Value from FormGroup
   * - Update/patch part of the object
   * @param apiNames
   */
  save(apiNames: string[]): void {
    if (!this.openModalIfStatusOffAndEditable(apiNames)) {
      this.saveEmit(apiNames);
    }
    this.store.dispatch(new LoadProductsCompleteListAction());
  }

  saveEmit(apiNames: string[]): void {
    if (apiNames[1] === 'subscription') {
      const cultures = { cultures : this.dataConfig.form.get(['subscription', 'cultures' , 'code']).value}
      const name = { name : this.dataConfig.form.get(['subscription', 'name' ]).value}
      const resp2 = this.dataConfig.form.get(apiNames[1]).value;
      this.saveForm.emit({ api: apiNames, data: {...resp2 , ...cultures , ...name }} );
    } else if (apiNames[1] === 'site') {
      const resp = this.dataConfig.form.get(apiNames[1]).value;
      const cultures = { cultures : this.dataConfig.form.get(['subscription', 'cultures' , 'code']).value}
      this.saveForm.emit({ api: apiNames, data: {...resp , ...cultures} } );
    } else  {
      const resp = this.dataConfig.form.get(apiNames[1]).value;
      this.saveForm.emit({ api: apiNames, data: resp } );
    }

  }

  undo(formPath: string[]): void {
    if (formPath && formPath[0] === 'concepts') {
      this.loadConcept()
    } else {
      this.dataConfig.form.get(formPath).reset();
      this.dataConfigContentPatchForm(formPath);
      this.store.dispatch(new LoadProductsCompleteListAction());
    }
  }

  isStatusEditable(): boolean {
    return this.dataConfig.form.get(['subscription', 'status', 'id']).value === 1
      && this.dataConfig.groupConfigs.groupConfigs[1].config[2].presentation === 'edit'
  }

  openModalIfStatusOffAndEditable(apiNames: string[]): boolean {
    if (this.isStatusEditable() && apiNames[1] === 'subscription') {
      this.statusToOff.open();
      this.sub$ = this.statusToOff._send.subscribe(response => {
        if (response) {
          this.setStatusPresentationInDetailIfOff();
          this.saveEmit(apiNames);
        }
      });
      this.subscriptions.push(this.sub$);
      return true;
    }
    return false;
  }

  cultureValueChangesMap(): void {
    this.dataConfig.form.get(['subscription', 'cultures']).valueChanges.subscribe((culture: Culture) => {
      if (culture.code) {
        this.mapCulture(culture);
      }
    });
  }

  timezoneValueChangesMap(): void {
    this.dataConfig.form.get(['site', 'timezone']).valueChanges.subscribe((timezone: Timezone) => {
      if (timezone.ianaCode) {
        this.mapTimeZone(timezone);
      }
    });
    this.servers$ = this.store.pipe(select(fromShared.selectors.getCMS));
  }

  productValueChanges(): void {
    this.isVideoProduct = (this.dataConfig.form.get(['subscription', 'service', 'id']).value === 2);
  }

  // TODO: if used more than once create a service
  mapCulture(selectedCulture: Culture): void {
    this.store.pipe(
      select(fromShared.selectors.getCulturesByCode, selectedCulture.code),
      skipWhile((data: Culture[]) => !data)
    ).subscribe(res => {
      if (res[0]) {
        this.dataConfig.form.get(['subscription', 'cultures']).patchValue(res[0], { onlySelf: true, emitEvent: false })
      }
    });
  }

  // TODO: if used more than once create a service
  mapTimeZone(selectedTimeZone: Timezone): void {
    this.store.pipe(
      select(fromShared.selectors.getTimezonesByIanaCode, selectedTimeZone.ianaCode),
      skipWhile((data: Timezone[]) => !data)
    ).subscribe(res => {
      if (res[0]) {
        this.dataConfig.form.get(['site', 'timezone']).patchValue(res[0], { onlySelf: true, emitEvent: false })
      }
    });

  }

  isOrderOpened(): Observable<boolean> {
    return this.siteGetInfoService.isOrderOpened()
  }

  get isStatusOff$(): Observable<boolean> {
    return this.siteGetInfoService.isStatusOff()
  }

  get isServiceVideo$(): Observable<boolean> {
    return this.siteGetInfoService.isServiceVideo()
  }
  getInvalidControls(form: FormGroup): string[] {
    if (isDevMode()) {
      return this.findInvalidControlsService.find(form);
    }
  }

}
